import { AspectRatio, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const ReviewItem = ({
  title,
  description
}: {
  title: string
  description: string
}) => {
  return (
    <VStack
      bg="white"
      py={6}
      px={4}
      my={4}
      borderRadius={10}
      w={350}
      alignItems="flex-start"
    >
      <AspectRatio w={100} ratio={100 / 16} position="relative">
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/stars-1711000517589.png"
          alt="Stars"
          fill
        />
      </AspectRatio>
      <Text textStyle="oralcareReviewItemTitle">{title}</Text>

      <Text textStyle="oralcareReviewItemDesc">{description}</Text>
    </VStack>
  )
}

const Review = () => {
  return (
    <VStack w="100%" pb={10}>
      <VStack
        data-aos="fade-up"
        mt={20}
        w="100%"
        alignItems={{
          base: 'center',
          md: 'center'
        }}
        justifyContent="flex-start"
      >
        <Text textStyle="oralcareHTUTittle" color="#000">
          What They Say About
        </Text>

        <Text
          textStyle="oralcareHTUTittle"
          textAlign={{
            base: 'center',
            md: 'center'
          }}
          color="#4c7538"
        >
          Health+ OralCare Mouthwash
        </Text>
      </VStack>

      <Flex
        data-aos="fade-up"
        justifyContent="space-between"
        alignItems={{
          base: 'center',
          md: 'flex-start'
        }}
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        w="100%"
        mt={10}
      >
        <HStack flex={1} w="100%" position="relative" justifyContent="center">
          <Flex position="absolute" top={10} left={0}>
            <AspectRatio
              w={{
                base: 160,
                sm: 200,
                md: 250
              }}
              ratio={427 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/review-leaf-left-1714039163853.png'
                }
                alt="review leaf left"
                fill
              />
            </AspectRatio>
          </Flex>

          <AspectRatio
            w={{
              base: '200px',
              sm: '250px',
              md: '300px'
            }}
            ratio={688 / 960}
            position="relative"
            zIndex={100}
            mt={10}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/three-bottle-1715151284733.png'
              }
              alt="group bottle"
              fill
            />
          </AspectRatio>
          <Flex position="absolute" top={10} right={0}>
            <AspectRatio
              w={{
                base: 180,
                sm: 230,
                md: 280
              }}
              ratio={477 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/review-leaf-right-1714039163853.png'
                }
                alt="review leaf right"
                fill
              />
            </AspectRatio>
          </Flex>
        </HStack>

        <VStack
          flex={1}
          alignItems="flex-start"
          gap={0}
          mt={{
            base: 20,
            md: 0
          }}
        >
          <ReviewItem
            title="Great Product !"
            description="Have been using for 2 years, her teeth are strong and white! She is in mid-70s years old!"
          />
          <ReviewItem
            title="Recommended !"
            description="I used the products for 3 months, teeth is whiter and gum less sensitive."
          />
          <ReviewItem
            title="Love the taste of the mouthwash!"
            description="It’s my 2nd purchase, Keep gum healthy and very fresh breath."
          />
        </VStack>
      </Flex>
    </VStack>
  )
}
export default Review
